import React from 'react';
import { motion } from 'framer-motion';
import { Phone, Sparkles, MessageCircle } from 'lucide-react';
export function Contact() {
  return <section id="contact" className="py-24 md:py-28 bg-warm-ivory relative overflow-hidden" data-id="element-40" data-mp="356lt3cn06d6d">
      
      {/* Delicate hairline top divider */}
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-soft-terracotta/20 to-transparent z-10" data-id="element-41" data-mp="2w7qizpgu8ixs"></div>

      <div className="max-w-4xl mx-auto px-6 md:px-12 relative z-20" data-id="element-42" data-mp="3swg3zonrhrnz">
        <div className="text-center mb-12" data-id="element-43" data-mp="3ovmguxi58gw5">
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="inline-block mb-6" data-id="element-44" data-mp="3owxstklqsuyc">
            
            <Sparkles className="w-6 h-6 text-[#FF83B4] mx-auto" strokeWidth={1} data-id="element-45" data-mp="ghvwlkfk5us9" />
            
          </motion.div>
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="font-display text-4xl md:text-5xl text-soft-terracotta mb-6 font-normal" data-id="element-46" data-mp="bnjdjbhzulh1">
            
            Let's Plan Magic
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-soft-dark font-light text-base" data-id="element-47" data-mp="3f4cp3ifjb164">
            
            Currently accepting bookings exclusively in Santa Barbara, CA.
          </motion.p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.2,
        duration: 0.8
      }} className="bg-warm-ivory px-8 py-12 md:px-14 md:py-14 rounded-3xl shadow-sm border border-soft-terracotta/20 text-center" data-id="element-48" data-mp="2w5gzkkemfaym">
          
          <Phone className="w-10 h-10 mx-auto mb-6 text-powder-blue" strokeWidth={1.25} aria-hidden="true" data-id="element-49" data-mp="1ycha986cvb15" />
          
          <p className="text-soft-dark font-light text-lg leading-relaxed max-w-md mx-auto mb-8" data-id="element-50" data-mp="1uadvoaoe3qbn">
            Call or text to start planning a celebration
            <br data-id="element-51" data-mp="1pdnka0nj5iwk" />
            made just for your little one.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-52" data-mp="2m0s61wx72kik">
            <motion.a whileHover={{
            scale: 1.02
          }} whileTap={{
            scale: 0.98
          }} href="tel:+18057709317" aria-label="Call Wishing Tree Events at 805 770 9317" className="w-full sm:w-auto inline-flex items-center justify-center rounded-full bg-soft-rose px-8 py-4 text-lg font-medium tracking-wide text-white shadow-sm hover-bg-soft-rose transition-colors focus:outline-none focus:ring-2 focus:ring-powder-blue focus:ring-offset-2" data-id="element-53" data-mp="2i1jd2u9zaqo2">
              
              (805) 770-9317
            </motion.a>
            <motion.a whileHover={{
            scale: 1.02
          }} whileTap={{
            scale: 0.98
          }} href="sms:+18057709317" aria-label="Send a text message to Wishing Tree Events at 805 770 9317" className="w-full sm:w-auto inline-flex items-center justify-center gap-2 rounded-full bg-white px-8 py-4 text-lg font-medium tracking-wide text-soft-terracotta border border-soft-terracotta/25 shadow-sm hover:bg-soft-terracotta hover:text-white hover:border-soft-terracotta transition-colors focus:outline-none focus:ring-2 focus:ring-powder-blue focus:ring-offset-2" data-id="element-54" data-mp="38clgml9aigmf">
              
              <MessageCircle className="w-5 h-5" strokeWidth={1.5} data-id="element-55" data-mp="4w4jgh6mfu37" />
              Text Us
            </motion.a>
          </div>
        </motion.div>
      </div>
    </section>;
}